import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons';
import './ScrollingPage.scss';

interface IProps {
  fade?: boolean;
  className?: string;
  children: any;
}

// Amazing thanks https://stackoverflow.com/questions/53845595/wrong-react-hooks-behaviour-with-event-listener
function useStateRef(initialValue: any) {
  const [value, setValue] = React.useState(initialValue);

  const ref = React.useRef(value);

  React.useEffect(
    () => {
      ref.current = value;
    },
    [value]
  );

  return [value, setValue, ref];
}

export const ScrollingPage: React.FC<IProps> = ({ fade, children, className }) => {
  let scrollableDiv: React.RefObject<HTMLDivElement> = React.useRef(null);
  const [scrollClass, setScrollClass, scrollRef] = useStateRef('');

  React.useEffect(() => {
    window.addEventListener('scroll', recalcScroll);
    return () => window.removeEventListener('scroll', recalcScroll);
  }, []);

  const recalcScroll = () => {
    const el = scrollableDiv.current;
    if (!el) {
      return;
    }

    // console.log(`${el.getBoundingClientRect().bottom} > ${window.innerHeight}`);
    const tmpScrollClass = el.getBoundingClientRect().bottom > window.innerHeight ? 'has-scroll-screen' : '';
    if (tmpScrollClass !== scrollRef.current) {
      setScrollClass(tmpScrollClass);
    }
  };

  React.useEffect(recalcScroll);
  // comment 
  return (
    <div ref={scrollableDiv} className={`${className || ''} ${scrollClass} ${fade ? 'has-fade' : ''}`}>
      {children}
      <span
        className='more-scroll-arrow'
        onClick={() =>
          scrollableDiv.current &&
          window.scrollTo({
            top: scrollableDiv.current.getBoundingClientRect().bottom,
          })
        }
      >
        <FontAwesomeIcon icon={faAngleDoubleDown} />
      </span>
    </div>
  );
};
